import { Box, useTheme } from '@mui/material'

import { TextParagraph } from 'presentation/components/elements'

type ThereIsNotInformationToShowProps = {
  message: string
}
export default function ThereIsNotInformationToShow({ message }: ThereIsNotInformationToShowProps) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        borderRadius: '15px',
        boxShadow: '0px 0px 0.875rem rgba(72, 64, 149, 0.14)',
        padding: '20px 10px',
        background: theme.palette.background.paper,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <TextParagraph fontSize="14px" color={theme.mixins.grey.color}>
        {message}
      </TextParagraph>
    </Box>
  )
}
